/**
 * WARNING. DANGER.
 * STOP!
 * THIS FILE IS DEPRECATED.
 * Do not add to this file
 * it will be deleted in the near future
 */
const {
  BlankMainPanelWrapper,
  TheModalWrapper,
  ViewportWrapper
} = require('client/components/VueComponentWrappers');
const {
  bindAll, extend, functions, get,
} = require('lodash');
const { ItemTypeConsts } = require('client/util/Constants');
const { xCSRFToken, xOrgIdHeader } = require('client/util/Constants').XhrConsts;
const GettingStartedPanelSettings = require('client/components/GettingStartedPanel/GettingStartedPanelSettings').default;
const MspState = require('client/components/models/MspState').default;
const NotificationsApi = require('client/api/v2/NotificationsApi').default;
const StaticConfig = require('client/util/StaticConfig');
const UserLockNoPaymentService = require('client/Payments/components/UserLockNoPaymentModal/UserLockNoPaymentService').default;
const store = require('client/store/index').default;
const util = require('client/util');
const LoggingService = require('client/util/LoggingService').default;

const settingsModule = 'SettingsModule';

const { hrDirectory, systemUser, sso } = ItemTypeConsts;

// Override backbone sync (for collections, etc.)
require('client/util/backbone-util');

module.exports = Backbone.View.extend({

  asidePanel: undefined,
  clipboard: undefined,
  headerPanel: undefined,
  mainPanel: undefined,
  navPanel: undefined,
  notificationsCount: 0,
  resourcesAnnouncement: undefined,

  initialize(options, callback) {
    const self = this;

    bindAll(self, functions(Object.getPrototypeOf(self)));
    self.options = options;

    if (self.options.vueApp) {
      self.dashboard = self.options.vueApp;
    } else {
      // Create the Vue component
      self.dashboard = self.createViewportContainer();
    }

    /**
     * Keep another reference to the Vue instance so we can access the store
     * from Backbone views and models. Call it 'settingsStore' to be somewhat
     * transparent.
     *
     * @todo My intention is that in the future the Viewport Vue component will
     * be the main container, the Backbone Viewport View will go away and
     * we won't have to keep a separate reference to the store.
     */
    self.settingsStore = self.dashboard;

    // Get the state for this session.  This is used to determine whether to
    // display the Standard view (w/wo the Nav Bar) or the Organization List view.
    self.setView()
      .then(() => {
        if (callback && typeof callback === 'function') callback.apply(self);
      })
      .catch((err) => {
        util.notify('error', `Error rendering page! ${err.message}`);
      });

    // This is useful for debugging in the Vue world
    window.viewport = this;
  },

  // NOTE: render() might get called more than once. Currently this happens with MTP.
  render() {
    LoggingService.debug('Viewport.render');
    const self = this;
    const { isAnMsp, orgId } = MspState;
    const disableCommandRunner = get(this.settingsStore, 'disableCommandRunner', false);
    const isCommandRunner = store.getters[`${settingsModule}/isCommandRunner`] || false;

    // This tooltip is specifically for the headers panel for gettingStarted
    if (!self.tooltipProps) {
      self.tooltipProps = {
        linkHref: '',
        pText: '',
      };
    }

    // Header panel props
    if (!self.headerPanelProps) {
      self.headerPanelProps = {
        notificationsCount: self.notificationsCount,
        title: '',
        tooltipProps: self.tooltipProps,
        viewport: self,
        openResourcesPanel: self.openResourcesPanel,
      };
    }

    // Initialize global 'TheModal' Vue component
    /**
     * @todo remove the modal loading with
     * https://jumpcloud.atlassian.net/browse/TN-247
     */
    const modalId = 'the-modal';

    const renderModal = () => {
      self.$el.append(`<div id="${modalId}"></div>`);
      new TheModalWrapper(`#${modalId}`, { viewport: self }).render();
    };

    if (!document.getElementById(modalId)) {
      renderModal();
    }

    UserLockNoPaymentService.initUserLockModalProcess(renderModal, modalId);

    /**
     * @todo find an alternative that doesn't use jQuery
     */
    require('public/js/vendor/jquery-cookie.js');
    /**
     * @todo remove when rolling out ui-components date picker
     */
    $.datepicker = require('public/js/vendor/bootstrap-datepicker.js');

    return self;
  },

  renderMainPanel(panel) {
    LoggingService.debug('Viewport.renderMainPanel: ', panel);
    // Clean up current panel
    if (this.mainPanel && this.mainPanel.cleanUp) {
      this.mainPanel.cleanUp();
      this.mainPanel = undefined;
    }

    // Set panel as new main panel
    this.mainPanel = panel;

    if (this.navPanel && this.navPanelProps) {
      this.navPanelProps.activeLink = panel.action;
    }

    this.tooltipProps.showTooltip = false;

    if (this.options.vueApp) {
      this.options.vueApp.setTitle(this.mainPanel.title);
      this.options.vueApp.setPlatformPlus(this.mainPanel.platformPlus);
    } else if (this.headerPanel && this.headerPanelProps) {
      this.headerPanelProps.title = this.mainPanel.title;
      this.headerPanelProps.platformPlus = this.mainPanel.platformPlus;
    }

    if (this.mainPanel) {
      if (this.mainPanel.component) {
        // If the main panel is a Vue component, just render
        this.mainPanel.render();
      } else {
        this.mainPanel.setElement('#backbone').render();
      }
    }

    // Pass the tooltip content for the current panel
    if (this.mainPanel && this.mainPanel.gettingStartedPanelItemType) {
      this.tooltipProps.linkHref = GettingStartedPanelSettings[this.mainPanel.gettingStartedPanelItemType].learnMoreUrl;
      this.tooltipProps.pText = GettingStartedPanelSettings[this.mainPanel.gettingStartedPanelItemType].tooltipText;
      this.tooltipProps.tooltipExtraLinks = GettingStartedPanelSettings[this.mainPanel.gettingStartedPanelItemType].tooltipExtraLinks;

      if (
          this.mainPanel.gettingStartedPanelItemType === systemUser
          || this.mainPanel.gettingStartedPanelItemType === hrDirectory
          || this.mainPanel.gettingStartedPanelItemType === sso
        ) {
        this.tooltipProps.linkHref = GettingStartedPanelSettings[this.mainPanel.gettingStartedPanelItemType]({}).learnMoreUrl;
        this.tooltipProps.pText = GettingStartedPanelSettings[this.mainPanel.gettingStartedPanelItemType]({}).tooltipText;
      }

      const vueApp = this.options.vueApp;
      
      if (this.mainPanel.gettingStartedPanelItemType === sso && vueApp.ssoNavBarExperimentActive) {
        vueApp.setTitle("Applications")
      }
    }

    if (this.options.vueApp) {
      if(this.mainPanel.gettingStartedPanelItemType == null) {
        LoggingService.debug('setTooltip null ', );
        this.options.vueApp.setTooltip(undefined);
      } else {
        LoggingService.debug('setTooltip something', this.tooltipProps);
        this.options.vueApp.setTooltip(this.tooltipProps);
      }
    }
  },

  renderBlankPanel() {
    // This should be fine to skip if we are not in the correct child view
    if (this.options.vueApp.$children[0]._name === '<AdminPortalMain>') {
      $('#backbone').empty().append('<div id="main-panel"></div>');
      this.renderMainPanel(new BlankMainPanelWrapper('#main-panel', {
        isAsideOpen: false,
        viewport: this,
        selectedModelId: '',
      }));
    }
  },

  renderAsidePanel(panel) {
    LoggingService.debug('Viewport.renderAsidePanel: ', panel);
    // Clean up current panel
    if (this.asidePanel && this.asidePanel.cleanUp) {
      this.asidePanel.cleanUp();
      this.asidePanel = undefined;
    }

    // Set panel as new aside panel
    this.asidePanel = panel;
    // .last() because with VueRouter navigation from aside to another aside might
    // mean there are 2. The bootstrap one will always be second.
    this.asidePanel.setElement(jQuery('aside').last()).render();

    if (this.asidePanel.on) {
      this.asidePanel.on('canceled', () => {
        this.resetItemList();
      });
      this.asidePanel.on('saved', () => {
        this.resetItemList();
      });
    }
  },

  resetItemList() {
    if (this.mainPanel && this.mainPanel.itemList) {
      this.mainPanel.itemList.refresh();
      this.mainPanel.itemList.setSelectedModelId(null);
    }
  },

  getMainPanelAction() {
    if (this.mainPanel && this.mainPanel.action) {
      return this.mainPanel.action;
    }
    return null;
  },

  ajax(settings) {
    if (typeof settings !== 'object') {
      throw new Error('Cannot perform ajax request without settings');
    }

    // Add csrf and orgId to requests
    settings.headers = extend({}, settings.headers, {
      [xCSRFToken]: this.settingsStore.csrfToken,
      [xOrgIdHeader]: this.settingsStore.orgId,
    });

    // Any necessary settings overrides can go here
    const settingsOverrides = {};

    // Perform ajax request
    return $.ajax(extend({}, settings, settingsOverrides));
  },

  redirect(href) {
    window.location.href = href;
  },

  isAsideOpen() {
    return this.$el.closest('body').hasClass('aside-expanded');
  },

  openAside(callback) {
    LoggingService.debug('Viewport.openAside');
    // If the aside is open, skip the open animation and just fire callback if we have one
    if (this.isAsideOpen()) {
      if (typeof callback === 'function') {
        callback();
      }
      return;
    }

    // Fire event to main panel item list if it exists
    if (this.mainPanel && this.mainPanel.itemList && this.mainPanel.itemList.setAsideOpenState) {
      this.mainPanel.itemList.setAsideOpenState(true);
    }

    // Update main panel props
    if (this.mainPanel && this.mainPanel.data) {
      this.mainPanel.data.isAsideOpen = true;
    }

    // Open up the aside and delay the callback with enough time for the animation to complete
    window.setTimeout(() => {
      this.$el.closest('body').addClass('aside-expanded');

      if (typeof callback === 'function') {
        setTimeout(callback, StaticConfig.PANEL_SPEED_MILLISECONDS);
      }
    });
  },

  closeAside(callback) {
    LoggingService.debug('Viewport.closeAside');
    // If the aside isn't open, skip the close animation and just fire callback if we have one
    if (!this.isAsideOpen()) {
      if (typeof callback === 'function') {
        callback();
      }
      return;
    }

    // Clean up current panel
    if (this.asidePanel && this.asidePanel.cleanUp) {
      this.asidePanel.cleanUp();
    }

    this.asidePanel = undefined;

    // Fire event to main panel item list if it exists
    if (this.mainPanel && this.mainPanel.itemList && this.mainPanel.itemList.setAsideOpenState) {
      this.mainPanel.itemList.setAsideOpenState(false);
    }

    // Update main panel props
    if (this.mainPanel && this.mainPanel.data) {
      this.mainPanel.data.isAsideOpen = false;
    }

    // Close up the aside and delay the callback with enough time for the animation to complete
    this.$el.closest('body').removeClass('aside-expanded');
    if (typeof callback === 'function') {
      setTimeout(callback, StaticConfig.PANEL_SPEED_MILLISECONDS);
    }
  },

  transitionAsidePanel(panel, callback) {
    const self = this;
    self.closeAside(() => {
      self.renderAsidePanel(panel);
      self.openAside(callback);
    });
  },

  initAdminConsole() {
    const isCommandRunner = store.getters[`${settingsModule}/isCommandRunner`] || false;

    const { csrfToken } = this.settingsStore;
    const orgId = this.settingsStore.orgId || '';

    // Ensure the CSRF token and OrgId headers are present in all requests made
    // with jQuery.ajax() and that the cache and statusCode options set globally
    // in backbone-util are not lost.

    const oldOptions = $.ajaxSetup();
    const newOptions = {
      cache: oldOptions.cache,
      headers: {
        [xCSRFToken]: csrfToken,
        [xOrgIdHeader]: orgId,
      },
      statusCode: oldOptions.statusCode,
    };

    $.ajaxSetup(newOptions);

    // Create the panels and set other global params
    this.canShowBoundItems = true;
  },

  /**
   * @description Remove panels for org list view
   */
  resetAdminConsole() {
    LoggingService.debug('Viewport.resetAdminConsole');
    if (this.mainPanel && this.mainPanel.cleanUp) {
      this.mainPanel.cleanUp();
    }
    if (this.asidePanel && this.asidePanel.cleanUp) {
      this.asidePanel.cleanUp();
    }
    this.mainPanel = undefined;
    this.asidePanel = undefined;

    this.clearNotificationsUpdate();
    this.clearResourceAddedWatches();
  },

  /**
   * @description Create Viewport Vue component
   */
  createViewportContainer() {
    // Provide a DOM element for the Vue component; this component creates the
    // Settings store
    this.$el.prepend('<div id="portal-navigation"></div>');

    const viewportContainer = new ViewportWrapper(
      '#portal-navigation',
      {},
    );
    viewportContainer.render();

    return viewportContainer.getComponent();
  },

  /**
   * @description Determine the Msp State based on the admin's information and
   * set the view accordingly.
   *
   * @todo this needs to move into AdminPortalApp to deprecate Viewport
   */
  setView() {
    return new Promise((resolve) => {
      const self = this;

      const finishSettingView = () => {
        self.initAdminConsole();
        self.updateNavPanel();
        if (typeof self.dashboard.showStandardView === 'function') {
          self.dashboard.showStandardView(MspState.isAnMsp);
        }
      };

      finishSettingView();
      resolve();
    });
  },

  /**
   * @description Syncs the navigation panel props with the settings of the org
   */
  updateNavPanel() {
    if (this.navPanel) {
      const disableCommandRunner = get(this.settingsStore, 'disableCommandRunner', false);
      this.navPanelProps.disableCommandRunner = disableCommandRunner;
      this.navPanelProps.isCommandRunner = store.getters[`${settingsModule}/isCommandRunner`] || false;
    }
  },

  /**
   * Update the notifications count.
   */
  fetchNotificationsCount() {
    NotificationsApi.fetch()
      .then((data) => {
        this.notificationsCount = get(data, 'totalCount', 0);
        if (this.headerPanelProps) {
          this.headerPanelProps.notificationsCount = this.notificationsCount;
        }
      })
      .catch(() => {
        util.notify('error', 'Unable to retrieve notifications');
      });
  },

  /**
   * Set an interval to update the notifications count every 30 seconds
   */
  setNotificationsUpdate() {
    this.notificationsCount = 0;
    this.fetchNotificationsCount();
    this.notificationsCountUpdateInterval = setInterval(this.fetchNotificationsCount, 30000);
  },

  /**
   * Clear the 30-second interval that updates the notifications count
   */
  clearNotificationsUpdate() {
    if (this.notificationsCountUpdateInterval) {
      clearInterval(this.notificationsCountUpdateInterval);
    }
  },

  clearResourceAddedWatches() {
    if (this.directoryAddedInterval) clearInterval(this.directoryAddedInterval);
    if (this.systemAddedInterval) clearInterval(this.systemAddedInterval);
  },
});